import React from "react";
import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { useCardcaseModel } from "../cardcaseModel";
import { YhBox } from "@/components/YhBox";

export const DataBox = () => {
    const { setICardcaseDrawer, selectedRowKeys, setGroupVisible, disableCardcase } = useCardcaseModel();

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setICardcaseDrawer("add")}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行操作");
                    return;
                }
                setICardcaseDrawer("edit")
            }}
        >编辑</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行操作");
                    return;
                }
                disableCardcase()
            }}
        >删除</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setGroupVisible(true)}
        >分组管理</Button>
    </>;

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}